import '../../../questionsSearch/questionsSearch.scss';
import { useState, useEffect } from 'react';
import HesSpinner from '../../../../components/loadingOverlay/hesSpinner';
import { useActivitySearchContext } from '../../context';
import { useFilterVocabulariesMutation, useGetFlashcardVocabulariesMutation, useGetPublicFlashcardVocabulariesMutation,
  useGetVocabularyByIdMutation, useSearchCastleVocabulariesMutation, useSearchExamVocabulariesMutation,
  useSelectRandomVocabulariesMutation, useSearchByVocabularyIdMutation } from '../../../../features/authentication/activitySearchApiSlice';
import VocabularyList from './VocabularyList';
import SearchFilter from '../../../questionsSearch/components/castleQuestionsSearch/components/questionResults/SearchFilter';
import VocabularyDetailsBar from './vocabualryDetailsBar';
import ActivityTypes from '../../../../enums/activityTypes';

const VocabularyResults = () => {
  const [searchCastleVocabulariesCall, { isLoading: vocabularySearching }] = useSearchCastleVocabulariesMutation();
  const [getVocabularyByIdCall, { isLoading: vocabularyLoading }] = useGetVocabularyByIdMutation();
  const [selectRandomVocabulariesCall, { isLoading: randomVocabulariesLoading }] = useSelectRandomVocabulariesMutation();
  const [filterVocabulariesCall, { isLoading: filterVocabulariesLoading }] = useFilterVocabulariesMutation();
  const [searchExamVocabulariesCall, { isLoading: searchExamVocabulariesLoading }] = useSearchExamVocabulariesMutation();
  const [yourFlashcardsSearchCall, { isLoading: yourFlashcardsSearchLoading }] = useGetFlashcardVocabulariesMutation();
  const [getPublicFlashcardsCall, { isLoading: isPublicFlashcardsSearching }] = useGetPublicFlashcardVocabulariesMutation();
  const [searchByVocabularyIdCall, { isLoading: isVocabularyIdSearching }] = useSearchByVocabularyIdMutation();

  const activitySearchContext = useActivitySearchContext();
  const [isError, setIsError] = useState(false);
  const [vocabularies, setVocabularies] = useState([]);
  const [vocabulariesCount, setVocabulariesCount] = useState(0);
  const [filterToShow, setFiltersToShow] = useState([]);
  const [topicsFilter, setTopicsFilter] = useState([]);
  const [pageCount,setPageCount] = useState(0);
  const [selectedPage, setSelectedPage] = useState(1);
  const [selectedVocabularies, setSelectedVocabularies] = useState([]);
  const [vocabulariesPerPage, setVocabulariesPerPage] = useState(25);
  const [filterChange, setFilterChange] = useState(false);
  const [keywords, setKeywords] = useState();
  const [currentSearchData, setCurrentSearchData] = useState({});
  const [originalSearchRequest, setOriginalSearchRequest] = useState({});
  const [dateBasedKey, setDateBasedKey] = useState(new Date().getTime().toString());
  const [originalVocabulariesList, setOriginalVocabulariesList] = useState([]);
  var tempTopicFlatTree = [];
  
  useEffect(() => {
    if(activitySearchContext.apiIdentifier.length > 0 && activitySearchContext.apiParams){
      callByApiIdentifier();
    }
  }, [activitySearchContext.apiIdentifier, activitySearchContext.apiParams]);

  useEffect(() => {
    if(activitySearchContext.resetQuestions){
      activitySearchContext.setShowResults(false);
      setVocabularies([]);
      setOriginalVocabulariesList([]);
      setVocabulariesCount(0);
      activitySearchContext.setResetQuestions(false);
      activitySearchContext.setActivityName('');
    }
  }, [activitySearchContext.resetQuestions]);

  const callByApiIdentifier = () => {
    switch (activitySearchContext.apiIdentifier) {
    case 'vocabularySearch':
      InitializeVocabularySearch(activitySearchContext.apiParams);
      break;
    case 'stateTestSearch':
      InitializeStateTestSearch(activitySearchContext.apiParams);
      break;
    case 'yourFlashcardSearch':
      InitializeYourFlashcardsSearch(activitySearchContext.apiParams);
      break;
    case 'publicFlashcardSearch':
      InitializePublicFlashcardsSearch(activitySearchContext.apiParams);
      break;
    case 'vocabularyIdSearch':
      InitializeVocabularyIdSearch(activitySearchContext.apiParams);
      break;
    }
  };

  const InitializeVocabularySearch = (searchRequest) => {
    activitySearchContext.setShowResults(true);
    setKeywords(searchRequest.keyword);
    setCurrentSearchData({ ...searchRequest, searchType: 'vocabularySearch' });
    setOriginalSearchRequest({ ...searchRequest, searchType: 'vocabularySearch' });
    setVocabulariesPerPage(searchRequest.pageSize);
    setFiltersToShow(['contentArea', 'levels', 'topics', 'personalAssignments', 'publicAssignments']);
    searchCastleVocabulariesCall(searchRequest).then((results) => { MapSearchResults(results, true); setSelectedPage(searchRequest.pageNumber); });
  };

  const InitializeStateTestSearch = (searchRequest) => {
    activitySearchContext.setIsSearching(true);
    setVocabularies([]);
    activitySearchContext.setShowResults(true);
    setKeywords(searchRequest.keyword);
    setFiltersToShow(['contentArea', 'levels', 'topics', 'personalAssignments', 'publicAssignments']);
    setCurrentSearchData({ ...searchRequest, searchType: 'stateTestSearch' });
    setOriginalSearchRequest({ ...searchRequest, searchType: 'stateTestSearch' });
    setVocabulariesPerPage(25);

    searchExamVocabulariesCall(searchRequest).then((results) => { MapSearchResults(results, true); setSelectedPage(1); });
  };

  const InitializeYourFlashcardsSearch = (searchRequest) => {
    activitySearchContext.setIsSearching(true);
    setVocabularies([]);
    activitySearchContext.setShowResults(true);
    setKeywords(searchRequest.keyword);
    setFiltersToShow(['contentArea', 'levels', 'topics', 'personalAssignments', 'publicAssignments']);
    setCurrentSearchData({ ...searchRequest, searchType: 'yourFlashcardsSearch' });
    setOriginalSearchRequest({ ...searchRequest, searchType: 'yourFlashcardsSearch' });
    setVocabulariesPerPage(25);

    yourFlashcardsSearchCall(searchRequest).then((results) => { MapSearchResults(results, true); setSelectedPage(1); });
  };

  const InitializePublicFlashcardsSearch = (searchRequest) => {
    activitySearchContext.setIsSearching(true);
    setVocabularies([]);
    activitySearchContext.setShowResults(true);
    setKeywords(searchRequest.keyword);
    setFiltersToShow(['contentArea', 'levels', 'topics', 'personalAssignments', 'publicAssignments']);
    setCurrentSearchData({ ...searchRequest, searchType: 'publicFlashcardsSearch' });
    setOriginalSearchRequest({ ...searchRequest, searchType: 'publicFlashcardsSearch' });
    setVocabulariesPerPage(25);

    getPublicFlashcardsCall(searchRequest).then((results) => { MapSearchResults(results, true); setSelectedPage(1); });
  };

  const InitializeVocabularyIdSearch = (searchRequest) => {
    searchRequest.courseId = 99;
    activitySearchContext.setIsSearching(true);
    setVocabularies([]);
    activitySearchContext.setShowResults(true);
    setKeywords(searchRequest.keyword);
    setCurrentSearchData({ ...searchRequest, searchType: 'VocabularyIdSearch' });
    setOriginalSearchRequest({ ...searchRequest, searchType: 'VocabularyIdSearch' });
    setVocabulariesPerPage(25);
    setFiltersToShow(['contentArea', 'levels', 'topics', 'personalAssignments', 'publicAssignments']);
    searchByVocabularyIdCall(searchRequest).then((results) => { MapSearchResults(results, true); setSelectedPage(1); });
  };

  const MapSearchResults = (searchResults, isNewSearch) => {
    activitySearchContext.setIsSearching(false);
    if (!searchResults?.data || !searchResults?.data?.success) {
      setIsError(true);

      activitySearchContext.setTopicFilters([]);
      activitySearchContext.setCourseFilters([]);
      activitySearchContext.setLevelFilters([]);
      activitySearchContext.setPersonalAssignmentFilters([]);
      activitySearchContext.setPublicAssignmentFilters([]);
      activitySearchContext.setContentAreaFilters([]);

      setVocabularies([]);
      setVocabulariesCount(0);

      if (searchResults.data && !searchResults.data.success) {
        setCurrentSearchData(originalSearchRequest);
        handleRetrySearch();
      }
      return;
    }
    let searchData = searchResults.data.vocabularies.map((item) => ({
      ...item,
      isSelected: selectedVocabularies.find(q => q.questionId == item.questionId) !== undefined,
      inAssignment: selectedVocabularies.find(q => q.questionId == item.questionId)?.inAssignment ?? false
    }));
    setVocabularies(searchData);
    setOriginalVocabulariesList(searchData);
    setIsError(false);
    setVocabulariesCount(searchResults.data.vocabularySearchFilters.totalVocabularyCount);

    if (isNewSearch) {  
      mapNewSearchFilters(searchResults.data.vocabularySearchFilters);
    } else {
      updateSearchFilters(searchResults.data.vocabularySearchFilters);
    }

    var classicCoursesCount = searchResults.data.vocabularySearchFilters.topicsTree?.filter(f => f.isClassicCourse).length;
    var newCoursesCount = searchResults.data.vocabularySearchFilters.topicsTree?.filter(f => !f.isClassicCourse).length;
    activitySearchContext.setShowClassicCoursesToggle(classicCoursesCount != 0 && newCoursesCount != 0);

    setPageCount(searchResults.data.vocabularySearchFilters.pageCount);
  };

  const flattenTreeFilter = (treeList, treeItem, parentId, filterClassicCourses) => {
    filterClassicCourses = !!filterClassicCourses;
    var itemIsHidden = false;
    if (filterClassicCourses) {
      itemIsHidden = treeItem.parent?.questionsCount == 0 || (parentId ? false : activitySearchContext.showClassicCourses ? !treeItem.isClassicCourse : treeItem.isClassicCourse);
    } else {
      itemIsHidden = treeItem.parent?.questionsCount == 0;
    }

    var treeItemId = treeItem?.parent?.id ? treeItem.parent.id : treeItem.parent.stringId;
    treeList.push({
      parentId: parentId,
      id: treeItemId,
      nodename: treeItem.parent.name,
      name: `${treeItem.parent.name} (${treeItem.parent.questionsCount})`,
      childIds: treeItem.children?.slice().sort((a, b) => (a.parent.name > b.parent.name) ? 1 : ((b.parent.name > a.parent.name) ? -1 : 0)).map(c => c.parent.id ? c.parent.id : c.parent.stringId),
      isChecked: false,
      checkIndeterminate: false,
      isExpanded: false,
      isSelected: false,
      isHidden: itemIsHidden
    });

    if (treeItem.children?.length > 0) {
      treeItem.children.slice().map((childItem) => flattenTreeFilter(treeList, childItem, treeItemId));
    }
  };


  const mapFilterToObject = (filter) => {
    return {
      id: filter.id ?? filter.stringId,
      name: filter.name,
      questionsCount: filter.questionsCount,
      isChecked: false,
      isApplied: false
    };
  };

  const mapNewSearchFilters = (filterResults) => {
    activitySearchContext.setContentAreaFilters(filterResults.courses?.map(filter => mapFilterToObject(filter)));
    activitySearchContext.setLevelFilters(filterResults.levels?.map(filter => mapFilterToObject(filter)));
    activitySearchContext.setPersonalAssignmentFilters(filterResults.teacherAssignments?.map(filter => mapFilterToObject(filter)));
    activitySearchContext.setPublicAssignmentFilters(filterResults.publicAssignments?.map(filter => mapFilterToObject(filter)));
    if (filterResults.topicsTree) [...filterResults.topicsTree].sort((a, b) => (a?.parent?.name || '').localeCompare(b?.parent?.name || '')).forEach((item) => flattenTreeFilter(tempTopicFlatTree, item, null, true));

    var showAllFilters = filterResults.topicsTree?.filter(f => f.isClassicCourse).length == 0 || filterResults.topicsTree?.filter(f => !f.isClassicCourse).length == 0;
    if (showAllFilters) tempTopicFlatTree = tempTopicFlatTree.map(t => ({ ...t, isHidden: false }));
    activitySearchContext.setTopicFilters(tempTopicFlatTree);
  };

  const updateFilterDetails = (filter, resultFilter) => {
    var exisitingFilter = resultFilter?.find(f => filter.id == (f.id ? f.id : f.stringId));

    return {
      ...filter,
      questionsCount: exisitingFilter?.questionsCount ?? 0,
      isChecked: exisitingFilter ? filter.isChecked : false,
      isApplied: exisitingFilter ? filter.isApplied : false
    };
  };

  const updateFilterTreeDetails = (filter, resultFilter, setFilterApplied) => {
    var existingFilter = resultFilter?.find(f => filter.id == f.id);

    if (existingFilter?.isChecked) setFilterApplied(true);
    return {
      ...filter,
      isChecked: existingFilter?.isChecked ?? false,
      isExpanded: existingFilter?.isExpanded ?? false,
      isSelected: existingFilter?.isSelected ?? false,
      checkIndeterminate: existingFilter?.checkIndeterminate ?? false
    };
  };

  const updateSearchFilters = (filterResults) => {
    activitySearchContext.setContentAreaFilters(fi => fi.map(filter => updateFilterDetails(filter, filterResults.courses)));
    activitySearchContext.setLevelFilters(fi => fi.map(filter => updateFilterDetails(filter, filterResults.levels)));
    activitySearchContext.setPersonalAssignmentFilters(fi => fi.map(filter => updateFilterDetails(filter, filterResults.teacherAssignments)));
    activitySearchContext.setPublicAssignmentFilters(fi => fi.map(filter => updateFilterDetails(filter, filterResults.publicAssignments)));
    [...filterResults.topicsTree]?.sort((a, b) => a?.parent?.name.localeCompare(b?.parent?.name)).forEach((item) => flattenTreeFilter(tempTopicFlatTree, item, null, true));
    activitySearchContext.setTopicFilters(a => {
      const newArray = a.map(ar => { return ar; });
      var showAllFilters = filterResults.topicsTree.filter(f => f.isClassicCourse).length == 0 || filterResults.topicsTree.filter(f => !f.isClassicCourse).length == 0;
      if (showAllFilters) tempTopicFlatTree = tempTopicFlatTree.map(t => ({ ...t, isHidden: false }));
      return tempTopicFlatTree.map(t => updateFilterTreeDetails(t, newArray, activitySearchContext.setTopicFiltersApplied));
    });
  };

  const handleRetrySearch = () => {
    switch (currentSearchData.searchType) {
    case 'vocabularySearch':
      searchCastleVocabulariesCall(currentSearchData).then((results) => { MapSearchResults(results, true); setSelectedPage(1); });
      break;
    case 'VocabularyIdSearch':
      searchByVocabularyIdCall(currentSearchData).then((results) => { MapSearchResults(results, true); setSelectedPage(1); });
      break;  
    }
  };

  const handleRemoveVocabulary = (vocabularyId) => {
    setSelectedVocabularies(selectedVocabularies.filter(q => q.questionId !== vocabularyId));
    setVocabularies(vocabularies.map((vocabulary) => ({ ...vocabulary, isSelected: vocabulary.questionId === vocabularyId ? false : vocabulary.isSelected })));
  };

  return (
    <>
      {activitySearchContext.showResults &&
        <div className='position-relative mt-3'>
          {(vocabularySearching || vocabularyLoading || randomVocabulariesLoading || filterVocabulariesLoading || searchExamVocabulariesLoading
           || yourFlashcardsSearchLoading || isPublicFlashcardsSearching || isVocabularyIdSearching) &&
            <div className='loadingOverlay'>
              <div className='loadingText'>
                <HesSpinner height='30%' maxHeight='230px' />
                <span className='ms-2'>Searching...</span>
              </div>
            </div>}
          <div className='d-flex flex-row mb-3 position-relative results-layout-row'>
            <SearchFilter
              filtersToShow={filterToShow}
              setCurrentSearchData={setCurrentSearchData}
              mapSearchResults={MapSearchResults}
              setSelectedPage={setSelectedPage}
              dataPerPage={vocabulariesPerPage}
              keywords={keywords}
              filterSearchCall={filterVocabulariesCall}
              dataFound={vocabulariesCount > 0}
              filterChange={filterChange}
              setFilterChange={setFilterChange}
              topicsFilter={topicsFilter}
              setTopicsFilter={setTopicsFilter}
              context={activitySearchContext}
              activityType= {ActivityTypes.FlashCard}
            />
            <VocabularyList
              count={vocabulariesCount}
              vocabularies={vocabularies}
              setVocabulariesList={setVocabularies}
              selectedVocabularies={selectedVocabularies}
              setSelectedVocabularies={setSelectedVocabularies}
              isError={isError}
              isSearching={vocabularySearching || vocabularyLoading || randomVocabulariesLoading || filterVocabulariesLoading
                 || searchExamVocabulariesLoading || yourFlashcardsSearchLoading || isPublicFlashcardsSearching || isVocabularyIdSearching}
              handleRetrySearch={handleRetrySearch}
              vocabulariesPerPage={vocabulariesPerPage}
              isGettingRandomVocabularies={false}
              callByApiIdentifier={callByApiIdentifier}
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
              goToVocabularyIdSearchCall={getVocabularyByIdCall}
              mapSearchResults={MapSearchResults}
              selectRandomVocabulariesCall={selectRandomVocabulariesCall}
              setDateBasedKey={setDateBasedKey}
              originalVocabulariesList={originalVocabulariesList}
              onRemove={handleRemoveVocabulary}
            />
          </div>
          {!isError && vocabulariesCount > 0 &&
            <VocabularyDetailsBar
              vocabulariesPerPage={vocabulariesPerPage}
              setVocabulariesPerPage={setVocabulariesPerPage}
              selectedVocabularies={selectedVocabularies}
              setSelectedVocabularies={setSelectedVocabularies}
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
              pageCount={pageCount}
              getPagedCastleVocabulariesCall={InitializeVocabularySearch}
              mapSearchResults={MapSearchResults}
              vocabularies={vocabularies}
              setVocabularies={setVocabularies}
              dateBasedKey={dateBasedKey}
              setDateBasedKey={setDateBasedKey}
              keywords={keywords}
              setCurrentSearchData={setCurrentSearchData}
              onRemove={handleRemoveVocabulary}
            />
          }
        </div>}
    </>
  );
};

export default VocabularyResults;